/* eslint-disable import/no-anonymous-default-export */
export default (insurance = [], action) => {
  switch (action.type) {
    case "GET_ALL_INSURANCE":
      return action.payload;
    case "NEW_INSURANCE":
      return [...insurance, action.payload];
    default:
      return insurance;
  }
};
